import { PropsWithChildren } from 'react';
import { MenuItem as MuiMenuItem, MenuItemProps as MuiMenuItemProps } from '@mui/material';

export type MenuItemProps = PropsWithChildren & MuiMenuItemProps;

export const MenuItem: React.FC<MenuItemProps> = ({ children, ...props }) => {
  return (
    <MuiMenuItem className="md-menu-item" disableGutters {...props}>
      {children}
    </MuiMenuItem>
  );
};
